module.exports = __webpack_public_path__ + "static/media/actions-portfile-icon.ea9f7068.png";